import { defineComponent as _defineComponent } from 'vue'
import { ReanalysisRequestType, StatusId } from '@/lib/enum';
import store from '@/store';
import { dispatchCreateReanalysisSds } from '@/store/main/actionsMain';
import { computed, ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReAnalysisSds',
  props: {
    statusId: null,
    sdsUuid: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  statusId: number;
  sdsUuid: string;
  disabled: boolean;
};

const $t = i18n.tc.bind(i18n);



const m = defineMessages({
  description1: 'このフォームは再データ化依頼のみを受け付けています。',
  description2:
    'その他のご要望（チェックリスト、CREATE-SIMPLE 等）は「{url}」からお願いいたします。',
});

const isOpenDialog = ref<boolean>(false);
const reanalysisSdsComment = ref<string>('');
const requestType = ref<string | null>(null);

const requestTypeItems = computed(() =>
  ReanalysisRequestType.values().map((type) => ({
    text: $t(type.messageId),
    value: type.value,
  }))
);

const commentPlaceholder = computed(() => {
  const selected = ReanalysisRequestType.values().find(
    (type) => type.value === requestType.value
  );
  return selected
    ? $t(selected.commentPlaceholderMessageId)
    : $t(sharedMessages.selectRequestTypeFirst);
});

const toggleIsOpenDialog = () => {
  isOpenDialog.value = !isOpenDialog.value;
};

const closeIsOpenDialog = () => {
  isOpenDialog.value = false;
  reanalysisSdsComment.value = '';
  requestType.value = null;
};

const handlSubmitReanalysisSds = async (): Promise<void> => {
  if (!requestType.value) {
    return;
  }
  await dispatchCreateReanalysisSds(store, {
    sdsId: props.sdsUuid,
    comment: reanalysisSdsComment.value.trim(),
    requestType: requestType.value,
  });
  closeIsOpenDialog();
};

return { __sfc: true,$t, props, m, isOpenDialog, reanalysisSdsComment, requestType, requestTypeItems, commentPlaceholder, toggleIsOpenDialog, closeIsOpenDialog, handlSubmitReanalysisSds, StatusId, sharedMessages, i18n }
}

})